<template>
  <div class="template-detail-body">
    <div class="ccui-app-container-detail2">
      <div class="ccui-app-container-detail-body">
        <el-group-title title="公告">
          <template slot="groupTitle">
            <div class="tip">
              <p class="tip-title">公告标题：公开招标公告</p>
              <p>
                公告内容：内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容内容
              </p>
            </div>
          </template>
        </el-group-title>
        <detailBaseTable
          :title="$t('page.content.Attachments')"
          :table-head="tableChangeHistoryHead"
          :table-data="tableChangeHistoryData"
        >
          <template slot="操作" slot-scope="{ row, $index }">
            <el-button size="mini" type="text" @click="goDetal(row, $index)">{{
              $t("page.content.Download")
            }}</el-button>
            <el-button size="mini" type="text" @click="preview(row)">{{
              $t("page.content.Yulan")
            }}</el-button>
          </template>
        </detailBaseTable>
        <!-- <div v-for="(item, index) in 2" :key="index" style="margin-bottom:15px"> -->
        <tableDetail :tableData="tableData" :flag="3"></tableDetail>
        <!-- </div> -->

        <detailBaseTable
          :title="$t('page.content.RelevantNotices')"
          :table-head="announcementListHead"
          :table-data="announcementListData"
        >
        </detailBaseTable>

        <!--底部功能按钮-->
        <div class="operate">
          <el-button type="text" icon="icon-ccui-agree" @click="participate">{{
            $t("page.content.Attend")
          }}</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getPreviewUrl } from "@/basa/utils";
import {
  qrySupJoinSchemeInfo,
  qryNoticeList
} from "@/app/myProjects/api/myProjects.js";
import tableDetail from "./components/tableDetail";
export default {
  name: "replyTenderAnnouncement",
  components: {
    tableDetail
  },
  data() {
    return {
      agentId: "", //agentId
      schemeId: "",
      supInfo: "",
      tableData: [{}], //包件信息
      flag: 3,
      // 附件列表
      tableChangeHistoryHead: [
        { label: this.$t("page.content.name"), prop: "protocolCode" },
        { label: this.$t("page.content.Description"), prop: "protocolName" },
        {
          label: this.$t("page.content.operation"),
          prop: "option",
          width: "100",
          slot: "操作"
        }
      ],
      tableChangeHistoryData: [],
      // 相关公告列表
      announcementListHead: [
        { label: this.$t("page.content.type"), prop: "protocolCode" },
        { label: this.$t("page.content.Title"), prop: "noticeTitle" },
        { label: this.$t("page.content.Stage"), prop: "purStep" },
        { label: this.$t("page.content.Publish"), prop: "createTime" }
      ],
      announcementListData: [] //
    };
  },
  created() {},
  mounted() {
    this.agentId = this.$router.history.current.query.a;
    this.schemeId = sessionStorage.getItem("schemeId");
    this.supInfo = JSON.parse(sessionStorage.getItem("supInfo"));
    console.log(this.schemeId);
    this.getSupJoinSchemeInfo();
  },
  methods: {
    getSupJoinSchemeInfo() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { supCode: this.supInfo.supCode }
      );
      qrySupJoinSchemeInfo(param).then(res => {
        if (res) {
          let obj = {
            isShowexeTime: true
          };
          this.$store.commit("edit", obj);
          // this.tableData = res.data.data.sscPackMatInfoBOS;
          console.log(res, "res===");
        }
      });
    },
    qryNoticeList() {
      let param = {};
      Object.assign(
        param,
        { schemeId: this.schemeId },
        { agentId: this.agentId },
        { supCode: this.supInfo.supCode }
      );
      qryNoticeList(param).then(res => {
        if (res) {
          // this.announcementListData = res.data.data.rows;
          console.log(res, "res<====");
        }
      });
    },
    participate() {
      this.$router.push({
        path: "replyTenderAnnouncementTo",
        query: { flag: 1 }
      });
    },
    //预览
    preview({ fileUrl }) {
      getPreviewUrl(fileUrl);
      //const previewSrc = getPreviewUrl(fileUrl);
      //window.open(previewSrc);
    }
  }
};
</script>
<style lang="scss" scoped>
.tip {
  padding-left: 20px;
  color: #4a4a4a;
  font-size: 13px;
  .tip-title {
    margin-bottom: 20px;
  }
}
.sub-contractor-detail-form-item {
  margin: 30px 20px;
}
.ccui-group-wrapper {
  /deep/ .el-table .el-table__body .cell {
    height: 36px;
    line-height: 36px;
  }
}
.sub-contractor-detail-body {
  color: #4a4a4a;
}
.sub-contractor-detail {
  margin: 15px 0 80px;
}
.breadName {
  margin-left: 10px;
}
.col-bottom {
  margin-bottom: 20px;
}
.operate {
  height: 40px;
  background: rgba(76, 76, 76, 0.8);
  text-align: center;
  .el-button {
    color: white;
  }
}
</style>
